import { render, staticRenderFns } from "./SinoticoParadas.vue?vue&type=template&id=ca2805a8&scoped=true&"
import script from "./SinoticoParadas.vue?vue&type=script&lang=js&"
export * from "./SinoticoParadas.vue?vue&type=script&lang=js&"
import style0 from "./SinoticoParadas.vue?vue&type=style&index=0&id=ca2805a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2805a8",
  null
  
)

export default component.exports